import { FormikErrors } from 'formik'

import { LoanTableFilterFormValues } from '@appTypes/App.interface'

import { loanPurposeOptions } from '@config/loanPurposeOptions'

interface Options {
    maxAmount: number,
    maxTerm: number,
    minAmount: number,
    minTerm: number
}

function isDivisibleBy100(value: number) {
    return value % 100 === 0
}

export const getLoansValidationSchema = (options: Options) => {
    return (values: LoanTableFilterFormValues) => {
        const errors: FormikErrors<LoanTableFilterFormValues> = {}

        if (!values.loanAmount) {
            errors.loanAmount = 'This field is required'
        } else if (values.loanAmount < options.minAmount) {
            errors.loanAmount = `Must be £${options.minAmount} or more.`
        } else if (values.loanAmount > options.maxAmount) {
            errors.loanAmount = `Must not be over £${options.maxAmount}.`
        } else if (!isDivisibleBy100(values.loanAmount)) {
            errors.loanAmount = 'Must be divisble by 100'
        }

        if (!values.loanTerm) {
            errors.loanTerm = 'This field is required'
        } else if (values.loanTerm < options.minTerm) {
            errors.loanTerm = `Must be ${options.minTerm} or more.`
        } else if (values.loanTerm > options.maxTerm) {
            errors.loanTerm = `Must not be over ${options.maxTerm}.`
        }

        if (
            !loanPurposeOptions.find(
                ({ value }) => value === values.loanPurpose
            )
        ) {
            errors.loanPurpose = 'This field is required.'
        }

        return errors
    }
}
